import axios from 'axios';
import { baseUrl } from '../utils/api';

export async function generateShareDescriptionAPI(payload) {
  const res = await axios.post(`${baseUrl}/ai/generate-share`, payload, { timeout: 60000 });
  return (res && res.data && res.data.description) ? res.data.description : '';
}
